import api from "./axios";

export interface TokenRenewRequest {
    refreshToken: string
}

export interface TokenResponse {
    token: {
        idToken: {
            SS: string;
        };
        refreshToken: {
            ID: string;
            SS: string;
            UID: string;
        };
    };
}

export const renewToken = (request: TokenRenewRequest) => {
    return api.post<TokenResponse>(
        "/account/token",
        request,
    );
}